import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url.to-json";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _extend from "lodash/extend";
import _isString from "lodash/isString";
import analytics from "web/script/analytics/analytics";
import eventEmitter from "web/script/mixins/event-emitter";
import { getRothkoEndpoint } from "web/script/routing/routes";
import logging from "web/script/utils/logging";
import url from "web/script/utils/url";
import requester from "./requester";
var cache = new Map();
var csrfToken = null;
/**
 * Creates a cache key from a template name and a query object.
 */

function getCacheKey(name) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  query = url.toURLSearchParams(query);
  query.sort();
  var cacheKey = name + ":";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = query.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          _name = _step$value[0],
          value = _step$value[1];

      cacheKey += "".concat(_name, "=").concat(value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return cacheKey;
}

var DEFAULT_OPTIONS = {
  cache: true
};

var RothkoError =
/*#__PURE__*/
function (_Error) {
  _inherits(RothkoError, _Error);

  function RothkoError() {
    _classCallCheck(this, RothkoError);

    return _possibleConstructorReturn(this, _getPrototypeOf(RothkoError).apply(this, arguments));
  }

  return RothkoError;
}(_wrapNativeSuper(Error));

export var Rothko =
/*#__PURE__*/
function () {
  /**
   * @param name The name of the template to fetch data for.
   * @param options
   */
  function Rothko(name, options) {
    _classCallCheck(this, Rothko);

    this._templateName = void 0;
    this._options = void 0;
    this._requestId = 0;
    this.on = eventEmitter.on;
    this.off = eventEmitter.off;
    this.trigger = eventEmitter.trigger;
    this._templateName = name;
    this._options = _extend({}, DEFAULT_OPTIONS, options);
  }

  _createClass(Rothko, [{
    key: "fetch",

    /**
     * Fetches the data for the template with the given params. Returns a Promise that will
     * resolve with the data returned from the API.
     *
     * If by the time the response has been received no other requests have been started on this
     * instance a 'data' event will be also be fired and if options.cache is true the response
     * will be cached.
     *
     * @param query The query params for this request.
     */
    value: function fetch(query) {
      // increment the request id so this request will have a new id
      this._requestId++; // generate a cache key for this request

      var cacheKey = getCacheKey(this._templateName, query); // if this instance is using the cache and we have an entry in the cache
      //  for this cacheKey then resolve without making a network request.
      // Using Promise.resolve() as we still want to guarantee async behaviour.

      if (this._options.cache && cache.has(cacheKey)) {
        return Promise.resolve(cache.get(cacheKey)).then(this.handleData.bind(this, this._requestId));
      } // otherwise make the API call


      var request = requester(getRothkoEndpoint() + this._templateName + "/", {
        query: query,
        logErrors: false
      });
      return request.then(requester.toJSON).then(this.successHandler.bind(this, this._requestId, cacheKey)).catch(this.failureHandler.bind(this, query));
    }
    /**
     * Generic success handler for requests to the Rothko API.
     */

  }, {
    key: "successHandler",
    value: function successHandler(requestId, cacheKey, responseJSON) {
      var data = responseJSON.data;
      csrfToken = responseJSON.csrf_token;

      if (this._options.cache) {
        cache.set(cacheKey, data);
      }

      return this.handleData(requestId, data);
    }
  }, {
    key: "handleData",
    value: function handleData(requestId, data) {
      if (requestId === this._requestId) {
        this.trigger("data", data);
      }

      analytics.updatePageViewInAnalyticsCookie();
      return data;
    }
    /**
     * Provides more explicit errors for failed fetches
     */

  }, {
    key: "failureHandler",
    value: function failureHandler(query, err) {
      this.trigger("error", err);

      if (query) {
        if (!_isString(query)) {
          query = url.toQueryString(query);
        }

        query = "?" + query;
      } // Data to log in newrelic to help identify the problem


      var data = {
        template: this._templateName,
        query: query,
        pageViewId: analytics.getPageViewId(),
        domain: window.location.host
      };
      var toReport = err;

      if (err instanceof Response) {
        toReport = new RothkoError( // Explicitly exclude the query parameters because NewRelic has no error grouping
        "Rothko call to ".concat(this._templateName, " responded with ").concat(err.status));
        console.error("Rothko call to %s%s responded with %s!", this._templateName, query || "", err.status);
      } else {
        console.error("Rothko call to %s%s failed:", this._templateName, query || "", err);
      }

      logging.reportError(toReport, data);
      return Promise.reject(toReport);
    }
  }]);

  return Rothko;
}();
/**
 * @param name The name of the template to fetch data for.
 * @param query The query params for this request.
 * @param options Options to pass to the Rothko instance.
 */

function fetch(name, query, options) {
  var rothko = new Rothko(name, options);
  return rothko.fetch(query);
}
/**
 * Clears the cache for either a specific template name or all templates.
 */


function clearCache(name) {
  if (!name) {
    cache.clear();
    return;
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = cache.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (key.startsWith(name + ":")) {
        cache.delete(key);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}
/**
 * Adds an entry to the cache
 */


function addCacheEntry(templateName, query, data) {
  cache.set(getCacheKey(templateName, query), data);
}

function getCSRF() {
  return csrfToken;
}

export default {
  Rothko: Rothko,
  fetch: fetch,
  clearCache: clearCache,
  addCacheEntry: addCacheEntry,
  getCSRF: getCSRF
};